import { render, staticRenderFns } from "./BackupEntry.vue?vue&type=template&id=072fefb8&scoped=true"
import script from "./BackupEntry.vue?vue&type=script&lang=js"
export * from "./BackupEntry.vue?vue&type=script&lang=js"
import style0 from "./BackupEntry.vue?vue&type=style&index=0&id=072fefb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fefb8",
  null
  
)

export default component.exports